module.exports = __webpack_public_path__ + "img/精致美型--多场景使用.9ff4498a.png";